import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const ContactPortalShell = ({
  user,
  onLogout,
  searchValue,
  onSearchChange,
  children
}) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window === 'undefined') {
      return true;
    }
    return window.innerWidth > 900;
  });
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 900) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const initials = useMemo(() => {
    const fullName = `${user?.first_name || ''} ${user?.last_name || ''}`.trim();
    if (fullName) {
      const parts = fullName.split(' ').filter(Boolean);
      return parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join('');
    }
    return (user?.email || 'U').charAt(0).toUpperCase();
  }, [user]);

  const isConsultasSection = location.pathname.startsWith('/consultas-y-reclamos');

  return (
    <div className="contact-shell-page">
      <header className="contact-shell-header">
        <button
          type="button"
          className="hamburger-btn"
          onClick={() => setSidebarOpen((prev) => !prev)}
          title="Menu principal"
        >
          ☰
        </button>

        <div className="shell-search-wrap">
          <input
            type="text"
            className="shell-search"
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Buscar por titulo, categoria o estado"
          />
        </div>

        <div className="shell-user-menu" ref={userMenuRef}>
          <button
            type="button"
            className="user-avatar-btn"
            onClick={() => setUserMenuOpen((prev) => !prev)}
            title={user?.fullname || user?.email}
          >
            <span className="user-avatar">{initials}</span>
          </button>

          {userMenuOpen && (
            <div className="user-dropdown-menu">
              <button type="button" onClick={onLogout}>Cerrar sesion</button>
            </div>
          )}
        </div>
      </header>

      <div className={`contact-shell-body ${sidebarOpen ? 'with-sidebar' : 'without-sidebar'}`}>
        <aside className={`contact-shell-sidebar ${sidebarOpen ? 'open' : 'collapsed'}`}>
          <nav className="shell-nav">
            <Link
              to="/consultas-y-reclamos"
              className={`shell-nav-item ${isConsultasSection ? 'active' : ''}`}
            >
              Consultas
            </Link>
          </nav>
        </aside>

        <main className="contact-shell-content">{children}</main>
      </div>
    </div>
  );
};

export default ContactPortalShell;
